// @owners { team: patients }
const resolutionValues = {
  skip: 'skip',
  cashPayOnly: "don't use insurance",
  insurance: 'use insurance',
};
export type ResolutionValues = (typeof resolutionValues)[keyof typeof resolutionValues];

/**
 * Derives onboarding insurance resolution from React Query insurance data (not Redux).
 */
export const deriveInsuranceResolution = ({
  isCashPayOnly,
  userInsuranceCount,
}: {
  isCashPayOnly: boolean;
  userInsuranceCount: number;
}): ResolutionValues => {
  if (isCashPayOnly) return resolutionValues.cashPayOnly;
  if (userInsuranceCount === 0) return resolutionValues.skip;
  return resolutionValues.insurance;
};
